import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import Spinner from 'react-spinkit';

import { auth } from '../../../firebase';
import { FormErrors } from '../../../errors/FormErrors';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: null,
  passwordOne: '',
  passwordTwo: '',
  error: null,
  success: false,
  validCode: null,
  verifiedCode: false,
  passwordOneValid: false,
  passwordTwoValid: false,
  formValid: false,
  formErrors: {passwordOne: '', passwordTwo: ''},
};

class PasswordReset extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    // Verify the password reset code is valid.
    auth
      .doVerifyPasswordResetCode(this.props.actionCode)
      .then(email => {
        this.setState({ email: email, validCode: true, verifiedCode: true });
      }, error => {
        // Invalid or expired action code. Ask user to try to reset the password
        // again.
        this.setState({ error: error.message, validCode: false, verifiedCode: true });
      });
  }

  handleResetPassword(event) {
    event.preventDefault();
    const { actionCode } = this.props;
    const newPassword = this.state.passwordOne;

    // Save the new password.
    auth
      .doPasswordReset(actionCode, newPassword)
      .then(() => {
        // Password reset has been confirmed and new password updated.
        this.setState({ success: true });
      }, error => {
        // Error occurred during confirmation. The code might have expired or the
        // password is too weak.
        this.setState(byPropKey('error', error));
      });
  }

  // setText(event) {
  //   this.setState({ passwordOne: event.target.value });
  // }

  validateInputData(name, value) {
    this.setState({[name]: value},
      () => { this.validateField(name, value)
    });
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let passwordOneValid = this.state.passwordOneValid;
    let passwordTwoValid = this.state.passwordTwoValid;

    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#\$%])(?=.{8,20})");

    switch(fieldName) {
      case 'passwordOne':
        passwordOneValid = strongRegex.test(value);
        fieldValidationErrors.passwordOne = passwordOneValid ? '': 'Password should be between 8 - 20 characters and should contain 1 lowercase, 1 uppercase, 1 special character out of @ # $ %';
        break;
      case 'passwordTwo':
        passwordTwoValid = this.state.passwordOne === this.state.passwordTwo;
        fieldValidationErrors.passwordTwo = passwordTwoValid ? '': 'Passwords don\'t match';
        break;
      default:
        break;
    }

    this.setState({formErrors: fieldValidationErrors,
                    passwordOneValid: passwordOneValid,
                    passwordTwoValid: passwordTwoValid
                  }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.passwordOneValid && this.state.passwordTwoValid});
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }

  render() {
    const {
      email,
      passwordOne,
      passwordTwo,
      error,
      success,
      validCode,
      verifiedCode,
      passwordOneValid,
      passwordTwoValid,
      formValid,
      formErrors,
    } = this.state;

    // const isInvalid =
    //   passwordOne !== passwordTwo ||
    //   passwordOne === '';

    let component;
    if (!verifiedCode) {
      component = (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>THE CRICKET SCOREBOOK</h1>
                      <br></br>
                      <Spinner name="ball-clip-rotate-multiple" color="steelblue"/>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (success) {
      component = (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>THE CRICKET SCOREBOOK</h1>
                      <h3>Password changed successfully</h3>
                      <p>You can now sign in with your new password</p>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (verifiedCode && validCode) {
      component = (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>THE CRICKET SCOREBOOK</h1>
                      <p className="text-muted">Reset your password</p>
                      <form onSubmit={this.handleResetPassword}>
                        <InputGroup className="`form-group ${this.errorClass(this.state.formErrors.passwordOne)}` mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-lock"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            value={passwordOne}
                            onChange={event => this.validateInputData('passwordOne', event.target.value)}
                            type="password"
                            placeholder="New Password"
                            maxLength="20"
                            minLength="8"
                            required
                          />
                        </InputGroup>
                        <InputGroup className="`form-group ${this.errorClass(this.state.formErrors.passwordTwo)}` mb-4">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-lock"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            value={passwordTwo}
                            onChange={event => this.validateInputData('passwordTwo', event.target.value)}
                            type="password"
                            placeholder="Re-enter New Password"
                            maxLength="20"
                            minLength="8"
                            required
                          />
                        </InputGroup>
                        <Button disabled={!this.state.formValid} type="submit" color="primary" onClick={this.handleResetPassword.bind(this)} block>
                          Reset Password
                        </Button>
                        <FormErrors formErrors={this.state.formErrors} />
                        { error && <p>{error.message}</p> }
                      </form>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      );
    } else if (verifiedCode && !validCode) {
      component = (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>THE CRICKET SCOREBOOK</h1>
                      <h3>Try resetting your password again</h3>
                      <p className="error">{error}</p>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }

    return component;
  }

}

export default PasswordReset;



// WEBPACK FOOTER //
// ./src/views/Pages/PasswordReset/PasswordReset.js